import { copy } from "./shared";
import ThankYouBody from "./ThankYouBody";
import "../templates/Template15.css";
import "./CheckoutTemplate15.css";

/*
   Checkout Template 15 — a seamless continuation of sales Template 15
   ("Warm Sunset Soft", light & cream). Reuses Template15.css directly (the
   .clp15-root design system): the real .ws15-nav, the warm .ws15-hero band,
   the .ws15-title, the .ws15-btn/.ws15-btn-p pill button and .ws15-foot
   footer. Only the form + order-summary cards are checkout-specific
   (CheckoutTemplate15.css), styled to match the template's pillowy warm cards.
*/
export default function ThankYouTemplate15({ data = {} }) {
  const c = copy(data);

  return (
    <div className="clp15-root">
      {/* NAV — same as the sales page (solid `scr` state for checkout) */}
      <nav className="ws15-nav scr">
        <div className="ws15-wrap ws15-nav-in">
          <span className="ws15-logo">
            {c.logo ? <img src={c.logo} alt="" /> : <span className="cok15-brandtext">{c.brand}</span>}
          </span>
          <span className="cok15-secure">✓ Order confirmed</span>
        </div>
      </nav>

      {/* HERO — reuses the sales hero band + title */}
      <header className="ws15-hero cok15-hero">
        <div className="ws15-wrap">
          <div className="cok15-hero-in">
            <span className="cok15-eyebrow">Thank you</span>
            <h1 className="ws15-title">
              You're <span className="cok15-accent">enrolled</span>
            </h1>
            {c.sub ? <p className="ws15-sub cok15-lead">{c.sub}</p> : null}
          </div>
        </div>
      </header>

      {/* FORM + ORDER SUMMARY — in the template's warm card style */}
      <div className="ws15-wrap">
        <ThankYouBody data={data} p="cok15" c={c} />
      </div>

      {/* FOOTER — same as the sales page */}
      <footer className="ws15-foot">
        <div className="ws15-wrap ws15-foot-in">
          <div className="cok15-foot">{c.guaranteeOn ? c.guarantee : `© ${c.brand}`}</div>
        </div>
      </footer>
    </div>
  );
}
